export type ModalSize = "small" | "medium" | "large" | "extraLarge" | "xxl";

export type FormMode = "add" | "update" | "delete" | "view";

// Standardized modal title: verb + noun, plus the entity name when one exists (edit/delete/view). Only "Add" is
// purely verb-noun. Keeps titles correct ("Edit X — Name") instead of reusing the button verb ("Save X").
export function modalTitle(
  mode: FormMode,
  entityLabel: string,
  name?: string | null,
): string {
  const suffix = name ? ` — ${name}` : "";
  switch (mode) {
    case "add":
      return `Add ${entityLabel}`;
    case "update":
      return `Edit ${entityLabel}${suffix}`;
    case "delete":
      return `Delete ${entityLabel}${suffix}`;
    case "view":
      return `${entityLabel}${suffix}`;
    default:
      return entityLabel;
  }
}

// The primary action button label. The button keeps "Save" on edit; only the title reads "Edit".
export function modalSubmitLabel(mode: FormMode): string {
  switch (mode) {
    case "add":
      return "Add";
    case "update":
      return "Save";
    case "delete":
      return "Delete";
    default:
      return "Submit";
  }
}

export enum ModalWidth {
  small = "w-[392px]",
  medium = "w-[512px]",
  large = "w-[768px]",
  extraLarge = "w-[1200px]",
  xxl = "w-[1250px]",
}

export enum ModalHeight {
  small = "w-[256px]",
  medium = "w-[392px]",
  large = "w-[768px]",
  extraLarge = "h-[600px]",
  xxl = "w-[1250px]",
}
